// Canonical edition maths — editions land on the 1st & 15th of each month.
// Issue Nº 1 = 1 September 2026. Anything earlier is the Preview Edition period.
const LAUNCH_Y = 2026;
const LAUNCH_M = 8; // September (0-based)

// Manual edition override (Studio → Editions → Engine & Switch). Synced from the API into
// localStorage; when set, "current edition" everywhere follows it instead of the calendar.
export const EDITION_OVERRIDE_KEY = "sme_edition_override";
const _editionOverride = (() => {
  try { const v = localStorage.getItem(EDITION_OVERRIDE_KEY); return v === null || v === "" ? null : parseInt(v, 10); } catch { return null; }
})();

// October 2026 and November 2026 each run as ONE full-month edition: the 15 Oct and 15 Nov
// slots are skipped, so Issue Nº 04 runs 1–30 Nov and Issue Nº 05 lands 1 Dec.
const SKIP_RAW_SLOTS = [3, 5]; // raw slot indexes of 15 Oct 2026 and 15 Nov 2026

export const cycleIndexFor = (d) => {
  if (d === undefined && _editionOverride !== null && Number.isFinite(_editionOverride)) return _editionOverride;
  const dt = new Date(typeof d === "number" ? d : (d ?? Date.now()));
  const months = (dt.getUTCFullYear() - LAUNCH_Y) * 12 + (dt.getUTCMonth() - LAUNCH_M);
  const raw = months * 2 + (dt.getUTCDate() >= 15 ? 1 : 0);
  return raw - SKIP_RAW_SLOTS.filter((s) => raw >= s).length;
};

export const issueNoFor = (d = Date.now()) => Math.max(0, cycleIndexFor(d) + 1);

export const editionStart = (idx) => {
  for (const s of SKIP_RAW_SLOTS) if (idx >= s) idx += 1;
  const months = Math.floor(idx / 2);
  const half = idx - months * 2;
  return new Date(Date.UTC(LAUNCH_Y, LAUNCH_M + months, half ? 15 : 1));
};
export const editionEnd = (idx) => new Date(editionStart(idx + 1).getTime() - 86400000);

const fmt = (dt) => dt.toLocaleDateString("en-GB", { day: "numeric", month: "short", timeZone: "UTC" });

export const editionLabel = (idx) =>
  idx < 0
    ? "Preview Edition · 1 – 31 August"
    : `Issue Nº ${String(idx + 1).padStart(2, "0")} · ${fmt(editionStart(idx))} – ${fmt(editionEnd(idx))}`;

// ISO date (yyyy-mm-dd) of an edition's first day — the natural drip/publish date.
export const editionStartIso = (idx) => editionStart(idx).toISOString().slice(0, 10);

// The next `count` upcoming editions (starting from the one after the current).
export const upcomingEditions = (count = 4) => {
  const cur = cycleIndexFor();
  return Array.from({ length: count }, (_, i) => cur + 1 + i);
};
